/* eslint-disable no-nested-ternary */
/* eslint-disable no-loop-func */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable no-restricted-syntax */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable react/jsx-pascal-case */
/* eslint-disable no-plusplus */
/* eslint-disable react/destructuring-assignment */
import { Table as MantineTable, Paper, Space } from '@mantine/core';
import { ReactNode } from 'react';
import calcularPreco from '../../../../../../business/proposals/estimate';
import PageSection from '../../../../../../components/core/PageSection/PageSection';
import {
  ProposalResiduePlanPackagingType,
  // ProposalResiduePlanQuotationEquipmentType,
  ProposalResiduePlanQuotationPackagingType,
  ProposalType,
} from '../../../../../../models/core/proposals.type';
import { Feature } from '../../../../../../utils/constants.utils';
import { formatCurrency } from '../../../../../../utils/formatter.utils';
import { isNullOrEmpty } from '../../../../../../utils/helper.utils';

type DataViewProps = {
  data: ProposalType;
};

export default function SummaryView(props: DataViewProps) {
  const formatOptionalCurrency = (value: unknown) => {
    return !isNullOrEmpty(value) ? formatCurrency(Number(value)) : null;
  };

  const formatSupplierValue = (quotation: any) => {
    return formatOptionalCurrency(quotation?.preco);
  };

  const formatCustomerValue = (quotation: any, compra: boolean, receita = false) => {
    if (isNullOrEmpty(quotation?.precificacao?.preco)) {
      return null;
    }

    const result = calcularPreco(
      quotation.preco,
      quotation.precificacao?.preco,
      quotation.precificacao?.imposto || 0,
      compra,
      receita
    );

    return formatOptionalCurrency(receita ? result.preco : result.novoPrecoComMargem);
  };

  const buildResidues = () => {
    const buildPackagingAndEquipment = () => {
      let items: ReactNode[] = [];

      for (const residue of props.data.residuos) {
        const plan = residue.planos.find((x) => x.primario);
        let quotations: any;

        // eslint-disable-next-line prefer-const
        quotations = plan?.cotacoes
          .filter((x) => x.primario)
          .map((y) => y.acondicionamentos)
          .flat();
        items = items.concat(
          plan?.acondicionamentos.map((y: ProposalResiduePlanPackagingType) => {
            return (
              <MantineTable.Tr
                key={`bpae_${residue.idPropostaResiduo}.${y.idPropostaResiduoPlanoAcondicionamento}`}
              >
                <MantineTable.Td>{`${residue.idPropostaResiduo}.${y.idPropostaResiduoPlanoAcondicionamento}`}</MantineTable.Td>
                <MantineTable.Td>{residue.residuoCliente}</MantineTable.Td>
                <MantineTable.Td>{y.residuoAcondicionamento}</MantineTable.Td>
                <MantineTable.Td>{y.gerenciar ? 'Sim' : 'Não'}</MantineTable.Td>
                <MantineTable.Td>{y.compartilhado ? 'Sim' : 'Não'}</MantineTable.Td>
                <MantineTable.Td>
                  {quotations
                    ?.filter(
                      (q: ProposalResiduePlanQuotationPackagingType) =>
                        q.idPropostaResiduoPlanoAcondicionamento === y.idPropostaResiduoPlanoAcondicionamento
                    )
                    .map((x: ProposalResiduePlanQuotationPackagingType) => {
                      return `${y.compartilhado ? `% de ${x.quantidade}` : y.quantidade} ${
                        x.quantidadeUnidadeMedida
                      }`;
                    })?.[0] || '-'}
                </MantineTable.Td>
              </MantineTable.Tr>
            );
          }) || []
        );

        // quotations = plan?.cotacoes
        //   .filter((x) => x.primario)
        //   .map((y) => y.equipamentos)
        //   .flat();
        items = items.concat(
          plan?.equipamentos.map((y) => {
            return (
              <MantineTable.Tr
                key={`bpeq_${residue.idPropostaResiduo}.${y.idPropostaResiduoPlanoEquipamento}`}
              >
                <MantineTable.Td>{`${residue.idPropostaResiduo}.${y.idPropostaResiduoPlanoEquipamento}`}</MantineTable.Td>
                <MantineTable.Td>{residue.residuoCliente}</MantineTable.Td>
                <MantineTable.Td>{y.residuoEquipamento}</MantineTable.Td>
                <MantineTable.Td>-</MantineTable.Td>
                <MantineTable.Td>-</MantineTable.Td>
                <MantineTable.Td>{`${y.quantidade} ${y.quantidadeUnidadeMedida}`}</MantineTable.Td>
                {/* <MantineTable.Td>
                  {quotations
                    ?.filter(
                      (q: ProposalResiduePlanQuotationEquipmentType) =>
                        q.idPropostaResiduoPlanoEquipamento === y.idPropostaResiduoPlanoEquipamento
                    )
                    .map((x: ProposalResiduePlanQuotationEquipmentType) => {
                      return `${x.quantidade} ${x.quantidadeUnidadeMedida}`;
                    })?.[0] || '-'}
                </MantineTable.Td> */}
              </MantineTable.Tr>
            );
          }) || []
        );
      }

      return (
        <>
          <PageSection
            size="md"
            color={Feature.Home.Proposal.color}
            label="Acondicionamento e Equipamento"
            text="Serão disponibilizados os acondicionamentos e equipamentos abaixo:"
          />
          <Space h="lg" />

          <MantineTable withTableBorder withColumnBorders withRowBorders striped>
            <MantineTable.Thead>
              <MantineTable.Tr>
                <MantineTable.Th>Ref.:</MantineTable.Th>
                <MantineTable.Th>Resíduo</MantineTable.Th>
                <MantineTable.Th>Item</MantineTable.Th>
                <MantineTable.Th>Gerenciar?</MantineTable.Th>
                <MantineTable.Th>Compartilhado?</MantineTable.Th>
                <MantineTable.Th>Quantidade</MantineTable.Th>
              </MantineTable.Tr>
            </MantineTable.Thead>
            <MantineTable.Tbody>{items}</MantineTable.Tbody>
          </MantineTable>
        </>
      );
    };

    const buildVehicle = () => {
      let items: ReactNode[] = [];

      for (const residue of props.data.residuos) {
        const plan = residue.planos.find((x) => x.primario);

        items = items.concat(
          plan?.veiculo
            ? [
                <MantineTable.Tr
                  key={`bv_${residue.idPropostaResiduo}.${plan.veiculo?.idPropostaResiduoPlanoVeiculo}`}
                >
                  <MantineTable.Td>{`${residue.idPropostaResiduo}.${plan.veiculo?.idPropostaResiduoPlanoVeiculo}`}</MantineTable.Td>
                  <MantineTable.Td>{residue.residuoCliente}</MantineTable.Td>
                  <MantineTable.Td>{plan.veiculo.residuoVeiculo}</MantineTable.Td>
                </MantineTable.Tr>,
              ]
            : []
        );
      }

      return (
        <>
          <PageSection
            size="md"
            color={Feature.Home.Proposal.color}
            label="Veículo"
            text="Serão utilizados os veículos abaixo:"
          />
          <Space h="lg" />

          <MantineTable withTableBorder withColumnBorders withRowBorders striped>
            <MantineTable.Thead>
              <MantineTable.Tr>
                <MantineTable.Th>Ref.:</MantineTable.Th>
                <MantineTable.Th>Resíduo</MantineTable.Th>
                <MantineTable.Th>Item</MantineTable.Th>
              </MantineTable.Tr>
            </MantineTable.Thead>
            <MantineTable.Tbody>{items}</MantineTable.Tbody>
          </MantineTable>
        </>
      );
    };

    const buildTreatmentAndDestination = () => {
      let items: ReactNode[] = [];

      for (const residue of props.data.residuos) {
        const plan = residue.planos.find((x) => x.primario);

        items = items.concat(
          plan?.tratamento
            ? [
                <MantineTable.Tr
                  key={`bt_${residue.idPropostaResiduo}.${plan.tratamento?.idPropostaResiduoPlanoTratamento}`}
                >
                  <MantineTable.Td>{`${residue.idPropostaResiduo}.${plan.tratamento?.idPropostaResiduoPlanoTratamento}`}</MantineTable.Td>
                  <MantineTable.Td>{residue.residuoCliente}</MantineTable.Td>
                  <MantineTable.Td>{plan.tratamento.residuoTratamento}</MantineTable.Td>
                </MantineTable.Tr>,
              ]
            : []
        );

        items = items.concat(
          plan?.destinoFinal
            ? [
                <MantineTable.Tr
                  key={`bd_${residue.idPropostaResiduo}.${plan.destinoFinal?.idPropostaResiduoPlanoDestinoFinal}`}
                >
                  <MantineTable.Td>{`${residue.idPropostaResiduo}.${plan.destinoFinal?.idPropostaResiduoPlanoDestinoFinal}`}</MantineTable.Td>
                  <MantineTable.Td>{residue.residuoCliente}</MantineTable.Td>
                  <MantineTable.Td>{plan.destinoFinal.residuoDestinoFinal}</MantineTable.Td>
                </MantineTable.Tr>,
              ]
            : []
        );
      }

      return (
        <>
          <PageSection
            size="md"
            color={Feature.Home.Proposal.color}
            label="Tratamento e Destinação"
            text="Serão realizados os tratamentos e destinações abaixo:"
          />
          <Space h="lg" />

          <MantineTable withTableBorder withColumnBorders withRowBorders striped>
            <MantineTable.Thead>
              <MantineTable.Tr>
                <MantineTable.Th>Ref.:</MantineTable.Th>
                <MantineTable.Th>Resíduo</MantineTable.Th>
                <MantineTable.Th>Item</MantineTable.Th>
              </MantineTable.Tr>
            </MantineTable.Thead>
            <MantineTable.Tbody>{items}</MantineTable.Tbody>
          </MantineTable>
        </>
      );
    };

    const buildPrice = () => {
      let items: ReactNode[] = [];
      let quotations: any;

      for (const residue of props.data.residuos) {
        const plan = residue.planos.find((x) => x.primario);

        quotations = plan?.cotacoes
          .filter((x) => x.primario)
          .map((y) => y.acondicionamentos)
          .filter((yy) => yy)
          .flat()
          .map((z) => {
            return {
              ...z,
              calcPrecoFornecedor: formatSupplierValue(z),
              calcQuantidadeFornecedor: z.quantidade
                ? `${z.quantidade} ${z.quantidadeUnidadeMedida} / ${z.frequenciaUnidadeMedida}`
                : null,
              calcPrecoCliente: formatCustomerValue(z, residue.compra),
              calcQuantidadeCliente: z.precificacao.quantidade
                ? `${z.precificacao.quantidade} ${z.precificacao.quantidadeUnidadeMedida} / ${z.precificacao.frequenciaUnidadeMedida}`
                : null,
            };
          });

        items = items.concat(
          plan?.acondicionamentos.map((y) => {
            const quotation = quotations?.find(
              (q: any) =>
                q.idPropostaResiduoPlanoAcondicionamento === y.idPropostaResiduoPlanoAcondicionamento
            );
            return (
              <MantineTable.Tr
                key={`bpa_${residue.idPropostaResiduo}.${y.idPropostaResiduoPlanoAcondicionamento}`}
              >
                <MantineTable.Td>{`${residue.idPropostaResiduo}.${y.idPropostaResiduoPlanoAcondicionamento}`}</MantineTable.Td>
                <MantineTable.Td>{residue.residuoCliente}</MantineTable.Td>
                <MantineTable.Td>Locação</MantineTable.Td>
                <MantineTable.Td>{y.residuoAcondicionamento}</MantineTable.Td>
                <MantineTable.Td>
                  {y.compartilhado ? '%' : `${y.quantidade} ${y.quantidadeUnidadeMedida}`}
                </MantineTable.Td>
                <MantineTable.Td>
                  {quotation?.calcPrecoFornecedor
                    ? `${quotation.calcPrecoFornecedor} |${quotation.calcQuantidadeFornecedor}`
                    : '-'}
                </MantineTable.Td>
                <MantineTable.Td>
                  {quotation?.calcPrecoCliente
                    ? `${quotation.calcPrecoCliente} | ${quotation.calcQuantidadeCliente}`
                    : '-'}
                </MantineTable.Td>
                <MantineTable.Td>{quotation?.observacao || '-'}</MantineTable.Td>
              </MantineTable.Tr>
            );
          }) || []
        );

        quotations = plan?.cotacoes
          .filter((x) => x.primario)
          .map((y) => y.equipamentos)
          .filter((yy) => yy)
          .flat()
          .map((z) => {
            return {
              ...z,
              calcPrecoFornecedor: formatSupplierValue(z),
              calcQuantidadeFornecedor: z.quantidade
                ? `${z.quantidade} ${z.quantidadeUnidadeMedida} / ${z.frequenciaUnidadeMedida}`
                : null,
              calcPrecoCliente: formatCustomerValue(z, residue.compra),
              calcQuantidadeCliente: z.precificacao.quantidade
                ? `${z.precificacao.quantidade} ${z.precificacao.quantidadeUnidadeMedida} / ${z.precificacao.frequenciaUnidadeMedida}`
                : null,
            };
          });
        items = items.concat(
          plan?.equipamentos.map((y) => {
            const quotation = quotations?.find(
              (q: any) => q.idPropostaResiduoPlanoEquipamento === y.idPropostaResiduoPlanoEquipamento
            );
            return (
              <MantineTable.Tr
                key={`bpe_${residue.idPropostaResiduo}.${y.idPropostaResiduoPlanoEquipamento}`}
              >
                <MantineTable.Td>{`${residue.idPropostaResiduo}.${y.idPropostaResiduoPlanoEquipamento}`}</MantineTable.Td>
                <MantineTable.Td>{residue.residuoCliente}</MantineTable.Td>
                <MantineTable.Td>Locação</MantineTable.Td>
                <MantineTable.Td>{y.residuoEquipamento}</MantineTable.Td>
                <MantineTable.Td>{`${y.quantidade} ${y.quantidadeUnidadeMedida}`}</MantineTable.Td>
                <MantineTable.Td>
                  {quotation?.calcPrecoFornecedor
                    ? `${quotation.calcPrecoFornecedor} | ${quotation.calcQuantidadeFornecedor}`
                    : '-'}
                </MantineTable.Td>
                <MantineTable.Td>
                  {quotation?.calcPrecoCliente
                    ? `${quotation.calcPrecoCliente} | ${quotation.calcQuantidadeCliente}`
                    : '-'}
                </MantineTable.Td>
                <MantineTable.Td>{quotation?.observacao || '-'}</MantineTable.Td>
              </MantineTable.Tr>
            );
          }) || []
        );

        quotations = plan?.cotacoes
          .filter((x) => x.primario)
          .map((y) => y.veiculo)
          .filter((yy) => yy)
          .flat()
          .map((z) => {
            return {
              ...z,
              calcPrecoFornecedor: formatSupplierValue(z),
              calcQuantidadeFornecedor: z.quantidade
                ? `${z.quantidade} ${z.quantidadeUnidadeMedida} / ${z.frequenciaUnidadeMedida}`
                : null,
              calcPrecoCliente: formatCustomerValue(z, residue.compra),
              calcQuantidadeCliente: z.precificacao.quantidade
                ? `${z.precificacao.quantidade} ${z.precificacao.quantidadeUnidadeMedida} / ${z.precificacao.frequenciaUnidadeMedida}`
                : null,
            };
          });

        const vehicleQuotation = quotations?.find(
          (q: any) => q.idPropostaResiduoPlanoVeiculo === plan?.veiculo?.idPropostaResiduoPlanoVeiculo
        );
        items = items.concat(
          plan?.veiculo
            ? [
                <MantineTable.Tr
                  key={`bpv_${residue.idPropostaResiduo}.${plan.veiculo.idPropostaResiduoPlanoVeiculo}`}
                >
                  <MantineTable.Td>{`${residue.idPropostaResiduo}.${plan.veiculo.idPropostaResiduoPlanoVeiculo}`}</MantineTable.Td>
                  <MantineTable.Td>{residue.residuoCliente}</MantineTable.Td>
                  <MantineTable.Td>Transporte</MantineTable.Td>
                  <MantineTable.Td>{plan.veiculo.residuoVeiculo}</MantineTable.Td>
                  <MantineTable.Td>{`${plan.veiculo.quantidade} ${plan.veiculo.quantidadeUnidadeMedida}`}</MantineTable.Td>
                  <MantineTable.Td>
                    {vehicleQuotation?.calcPrecoFornecedor
                      ? `${vehicleQuotation.calcPrecoFornecedor} | ${vehicleQuotation.calcQuantidadeFornecedor}`
                      : '-'}
                  </MantineTable.Td>
                  <MantineTable.Td>
                    {vehicleQuotation?.calcPrecoCliente
                      ? `${vehicleQuotation.calcPrecoCliente} | ${vehicleQuotation.calcQuantidadeCliente}`
                      : '-'}
                  </MantineTable.Td>
                  <MantineTable.Td>{vehicleQuotation?.observacao || '-'}</MantineTable.Td>
                </MantineTable.Tr>,
              ]
            : []
        );

        quotations = plan?.cotacoes
          .filter((x) => x.primario)
          .map((y) => y.tratamento)
          .filter((yy) => yy)
          .flat()
          .map((z) => {
            return {
              ...z,
              calcPrecoFornecedor: formatSupplierValue(z),
              calcQuantidadeFornecedor: z.quantidade ? `${z.quantidade} ${z.quantidadeUnidadeMedida}` : null,
              calcPrecoCliente: formatCustomerValue(z, residue.compra),
              calcQuantidadeCliente: z.precificacao.quantidade
                ? `${z.precificacao.quantidade} ${z.precificacao.quantidadeUnidadeMedida}`
                : null,
            };
          });
        const treatmentQuotation = quotations?.find(
          (q: any) =>
            q.idPropostaResiduoPlanoTratamento === plan?.tratamento?.idPropostaResiduoPlanoTratamento
        );
        items = items.concat(
          plan?.tratamento
            ? [
                <MantineTable.Tr
                  key={`bpt_${residue.idPropostaResiduo}.${plan.tratamento.idPropostaResiduoPlanoTratamento}`}
                >
                  <MantineTable.Td>{`${residue.idPropostaResiduo}.${plan.tratamento.idPropostaResiduoPlanoTratamento}`}</MantineTable.Td>
                  <MantineTable.Td>{residue.residuoCliente}</MantineTable.Td>
                  <MantineTable.Td>Destinação</MantineTable.Td>
                  <MantineTable.Td>{plan.tratamento.residuoTratamento}</MantineTable.Td>
                  <MantineTable.Td>-</MantineTable.Td>
                  <MantineTable.Td>
                    {treatmentQuotation?.calcPrecoFornecedor
                      ? `${treatmentQuotation.calcPrecoFornecedor} | ${treatmentQuotation.calcQuantidadeFornecedor}`
                      : '-'}
                  </MantineTable.Td>
                  <MantineTable.Td>
                    {treatmentQuotation?.calcPrecoCliente
                      ? `${treatmentQuotation.calcPrecoCliente} | ${treatmentQuotation.calcQuantidadeCliente}`
                      : '-'}
                  </MantineTable.Td>
                  <MantineTable.Td>{treatmentQuotation?.observacao || '-'}</MantineTable.Td>
                </MantineTable.Tr>,
              ]
            : []
        );

        quotations = plan?.cotacoes
          .filter((x) => x.primario)
          .map((y) => y.destinoFinal)
          .filter((yy) => yy)
          .flat()
          .map((z) => {
            return {
              ...z,
              calcReceita: z.receita,
              calcPrecoFornecedor: formatSupplierValue(z),
              calcQuantidadeFornecedor: z.quantidade ? `${z.quantidade} ${z.quantidadeUnidadeMedida}` : null,
              calcPrecoCliente: formatCustomerValue(z, residue.compra, z.receita!),
              calcQuantidadeCliente: z.precificacao.quantidade
                ? `${z.precificacao.quantidade} ${z.precificacao.quantidadeUnidadeMedida}`
                : null,
            };
          });
        const destinationQuotation = quotations?.find(
          (q: any) =>
            q.idPropostaResiduoPlanoDestinoFinal === plan?.destinoFinal?.idPropostaResiduoPlanoDestinoFinal
        );

        items = items.concat(
          plan?.destinoFinal
            ? [
                <MantineTable.Tr
                  key={`bpd_${residue.idPropostaResiduo}.${plan.destinoFinal.idPropostaResiduoPlanoDestinoFinal}`}
                >
                  <MantineTable.Td>{`${residue.idPropostaResiduo}.${plan.destinoFinal.idPropostaResiduoPlanoDestinoFinal}`}</MantineTable.Td>
                  <MantineTable.Td>{residue.residuoCliente}</MantineTable.Td>
                  <MantineTable.Td>Destinação</MantineTable.Td>
                  <MantineTable.Td>{plan.destinoFinal.residuoDestinoFinal}</MantineTable.Td>
                  <MantineTable.Td>-</MantineTable.Td>
                  <MantineTable.Td>
                    {destinationQuotation?.calcPrecoFornecedor
                      ? `${destinationQuotation.calcPrecoFornecedor} | ${
                          destinationQuotation.calcQuantidadeFornecedor
                        } ${destinationQuotation?.calcReceita ? ' (Compra)' : ''}`
                      : '-'}
                  </MantineTable.Td>
                  <MantineTable.Td>
                    {destinationQuotation?.calcPrecoCliente
                      ? `${destinationQuotation.calcPrecoCliente} | ${
                          destinationQuotation.calcQuantidadeCliente
                        }${destinationQuotation?.calcReceita ? ' (Compra)' : ''}`
                      : '-'}
                  </MantineTable.Td>
                  <MantineTable.Td>{destinationQuotation?.observacao || '-'}</MantineTable.Td>
                </MantineTable.Tr>,
              ]
            : []
        );
      }

      return (
        <>
          <PageSection
            size="md"
            color={Feature.Home.Proposal.color}
            label="Valores"
            text="Valores sobre cada item abaixo:"
          />
          <Space h="lg" />

          <MantineTable withTableBorder withColumnBorders withRowBorders striped>
            <MantineTable.Thead>
              <MantineTable.Tr>
                <MantineTable.Th>Ref.:</MantineTable.Th>
                <MantineTable.Th>Resíduo</MantineTable.Th>
                <MantineTable.Th>Tipo de Serviço</MantineTable.Th>
                <MantineTable.Th>Serviço</MantineTable.Th>
                <MantineTable.Th>Quantidade</MantineTable.Th>
                <MantineTable.Th>Fornecedor</MantineTable.Th>
                <MantineTable.Th>Cliente</MantineTable.Th>
                <MantineTable.Th>Obs</MantineTable.Th>
              </MantineTable.Tr>
            </MantineTable.Thead>
            <MantineTable.Tbody>{items}</MantineTable.Tbody>
          </MantineTable>
        </>
      );
    };

    return (
      <Paper shadow="xs" p="md" withBorder>
        <PageSection size="lg" color={Feature.Home.Proposal.color} label="Resíduos" text="" />
        <Space h="xs" />

        {buildPackagingAndEquipment()}
        <Space h="lg" />

        {buildVehicle()}
        <Space h="lg" />

        {buildTreatmentAndDestination()}
        <Space h="lg" />

        {buildPrice()}
      </Paper>
    );
  };

  const buildServices = () => {
    const buildPackagingAndEquipment = () => {
      let items: ReactNode[] = [];

      for (const service of props.data.servicos.filter(
        (x) => x.idResiduoAcondicionamento !== null || x.idResiduoEquipamento !== null
      )) {
        const quotation = service.cotacoes.find((x) => x.primario);
        const supplierPrice = formatSupplierValue(quotation);
        const customPrice = formatCustomerValue(quotation, false);

        items = items.concat(
          quotation
            ? [
                <MantineTable.Tr key={`sbpae_${service.idPropostaServico}`}>
                  <MantineTable.Td>{`${service.idPropostaServico}`}</MantineTable.Td>
                  <MantineTable.Td>{service.servico}</MantineTable.Td>
                  <MantineTable.Td>
                    {service.residuoAcondicionamento || service.residuoEquipamento}
                  </MantineTable.Td>
                  <MantineTable.Td>
                    {!service.idResiduoAcondicionamento ? '-' : service.gerenciar ? 'Sim' : 'Não'}
                  </MantineTable.Td>
                  <MantineTable.Td>
                    {!service.idResiduoAcondicionamento ? '-' : service.compartilhado ? 'Sim' : 'Não'}
                  </MantineTable.Td>
                  <MantineTable.Td>{service.quantidade}</MantineTable.Td>
                  <MantineTable.Td>
                    {supplierPrice
                      ? `${supplierPrice} | ${quotation.quantidade} ${quotation.frequenciaUnidadeMedida1} / ${quotation.frequenciaUnidadeMedida2}`
                      : '-'}
                  </MantineTable.Td>
                  <MantineTable.Td>
                    {customPrice
                      ? `${customPrice} | ${quotation.precificacao.quantidade} ${quotation.precificacao.quantidadeUnidadeMedida} / ${quotation.precificacao.frequenciaUnidadeMedida}`
                      : '-'}
                  </MantineTable.Td>
                  <MantineTable.Td>{quotation?.observacao || '-'}</MantineTable.Td>
                </MantineTable.Tr>,
              ]
            : []
        );
      }

      return (
        <>
          <PageSection
            size="md"
            color={Feature.Home.Proposal.color}
            label="Acondicionamento e Equipamento"
            text="Serão disponibilizados os acondicionamentos e equipamentos abaixo:"
          />
          <Space h="lg" />

          <MantineTable withTableBorder withColumnBorders withRowBorders striped>
            <MantineTable.Thead>
              <MantineTable.Tr>
                <MantineTable.Th>Ref.:</MantineTable.Th>
                <MantineTable.Th>Serviço</MantineTable.Th>
                <MantineTable.Th>Item</MantineTable.Th>
                <MantineTable.Th>Gerenciar?</MantineTable.Th>
                <MantineTable.Th>Compartilhado?</MantineTable.Th>
                <MantineTable.Th>Quantidade</MantineTable.Th>
                <MantineTable.Th>Fornecedor</MantineTable.Th>
                <MantineTable.Th>Cliente</MantineTable.Th>
                <MantineTable.Th>Obs</MantineTable.Th>
              </MantineTable.Tr>
            </MantineTable.Thead>
            <MantineTable.Tbody>{items}</MantineTable.Tbody>
          </MantineTable>
        </>
      );
    };

    const buildSupplier = () => {
      let items: ReactNode[] = [];

      for (const service of props.data.servicos.filter(
        (x) => x.idResiduoAcondicionamento === null && x.idResiduoEquipamento === null
      )) {
        const quotation = service.cotacoes.find((x) => x.primario);
        const supplierPrice = formatSupplierValue(quotation);
        const customPrice = formatCustomerValue(quotation, false);

        items = items.concat(
          quotation
            ? [
                <MantineTable.Tr key={`sbs_${service.idPropostaServico}`}>
                  <MantineTable.Td>{`${service.idPropostaServico}`}</MantineTable.Td>
                  <MantineTable.Td>{service.servico}</MantineTable.Td>
                  <MantineTable.Td>{service.jornada || '-'}</MantineTable.Td>
                  <MantineTable.Td>{`${service.quantidade} ${quotation.precificacao.quantidadeUnidadeMedida}`}</MantineTable.Td>
                  <MantineTable.Td>
                    {supplierPrice
                      ? `${supplierPrice} | ${quotation.quantidade} ${quotation.frequenciaUnidadeMedida1} / ${quotation.frequenciaUnidadeMedida2}`
                      : '-'}
                  </MantineTable.Td>
                  <MantineTable.Td>
                    {customPrice
                      ? `${customPrice} | ${quotation.precificacao.quantidade} ${quotation.precificacao.quantidadeUnidadeMedida} / ${quotation.precificacao.frequenciaUnidadeMedida}`
                      : '-'}
                  </MantineTable.Td>
                  <MantineTable.Td>{quotation?.observacao || '-'}</MantineTable.Td>
                </MantineTable.Tr>,
              ]
            : []
        );
      }

      return (
        <>
          <PageSection
            size="md"
            color={Feature.Home.Proposal.color}
            label="Profissional"
            text="Serão disponibilizados os profissionais abaixo:"
          />
          <Space h="lg" />

          <MantineTable withTableBorder withColumnBorders withRowBorders striped>
            <MantineTable.Thead>
              <MantineTable.Tr>
                <MantineTable.Th>Ref.:</MantineTable.Th>
                <MantineTable.Th>Serviço</MantineTable.Th>
                <MantineTable.Th>Jornada</MantineTable.Th>
                <MantineTable.Th>Quantidade</MantineTable.Th>
                <MantineTable.Th>Valor Fornecedor</MantineTable.Th>
                <MantineTable.Th>Valor Cliente</MantineTable.Th>
                <MantineTable.Th>Obs</MantineTable.Th>
              </MantineTable.Tr>
            </MantineTable.Thead>
            <MantineTable.Tbody>{items}</MantineTable.Tbody>
          </MantineTable>
        </>
      );
    };

    return (
      <Paper shadow="xs" p="md" withBorder>
        <PageSection size="lg" color={Feature.Home.Proposal.color} label="Serviços" text="" />
        <Space h="xs" />

        {buildPackagingAndEquipment()}
        <Space h="lg" />

        {buildSupplier()}
      </Paper>
    );
  };

  return (
    <Paper shadow="xs" p="md" withBorder>
      {buildResidues()}
      <Space h="lg" />
      {buildServices()}
    </Paper>
  );
}
